/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import { useGLTF } from '@react-three/drei'

export function AstronautHandsUp(props) {
  const { nodes, materials } = useGLTF('/models/astronaut-hands-up.glb')
  return (
    <group {...props} dispose={null}>
      <group position={[0.009, 0.348, 0.154]} scale={[0.263, 0.263, 0.208]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Roundcube055.geometry}
          material={materials['Astronaut red.001']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Roundcube055_1.geometry}
          material={materials['Astro White.001']}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Circle001.geometry}
          material={materials['Astronaut red.001']}
          position={[0.211, -1.383, 1.239]}
          rotation={[1.677, 0, 0]}
          scale={[0.126, 0.16, 0.127]}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube003.geometry}
          material={nodes.Cube003.material}
          position={[0, -1.372, 1.1]}
          rotation={[0.106, 0, 0]}
          scale={[3.133, 3.143, 3.955]}
        />
        <group position={[0, -1.731, 0]} scale={[4.114, 4.114, 5.204]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Roundcube053_1.geometry}
            material={materials['Astronaut red.001']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Roundcube053_2.geometry}
            material={materials['Astro White.001']}
          />
        </group>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Roundcube028.geometry}
          material={materials['Astro White.001']}
          position={[0, -1.367, 0]}
          scale={0.977}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Roundcube030.geometry}
          material={materials['Astro White.001']}
          position={[1.485, 1.611, 0.398]}
          scale={[-0.303, -0.429, -0.543]}
        />
        <group position={[0, 1.611, 0.398]} scale={[1.611, 1.611, 2.038]}>
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Roundcube057.geometry}
            material={materials['Black.001']}
          />
          <mesh
            castShadow
            receiveShadow
            geometry={nodes.Roundcube057_1.geometry}
            material={materials['Astro White.001']}
          />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/models/astronaut-hands-up.glb')